import React from 'react'
import { Text, View } from 'react-native'
import { tv } from 'tailwind-variants'

import { IMAGE } from '@ui-kit/assets/images/index.native'
import type { HeaderProps } from '@ui-kit/components/BottomSheet/types'
import ButtonIcon from '@ui-kit/components/ButtonIcon'
import Icon from '@ui-kit/components/Icon'
import { h4 } from '@ui-kit/core/typography'

const bottomSheetHeaderStyles = tv({
  slots: {
    container: 'flex flex-row items-center gap-x-2.5 py-5',
    titleContainer: 'flex-1',
    title: h4(),
  },
})

export const BottomSheetHeader = (props: HeaderProps & { onPress: () => void }) => {
  const styles = bottomSheetHeaderStyles()
  return (
    <View className={styles.container()}>
      {props.icon && <Icon imgSrc={props.icon} />}

      <View className={styles.titleContainer()}>
        {props.title ? <Text className={styles.title()}>{props.title}</Text> : null}
      </View>

      <ButtonIcon
        icon={<Icon imgSrc={IMAGE.icons.small.action.close_24} />}
        onPress={() => props.onPress()}
      />
    </View>
  )
}
